import React, {useState} from 'react'
//import {Link} from 'react-router-dom'
// Components
import {Form, Button} from 'semantic-ui-react'
import styles from './style.module.css'
import * as Yup from 'yup'
import useSWR from 'swr'
import {LoginPost} from "../../fetch/glossary"
import {fieldNames} from "../applications/options"
import {getApiResponseErrorMessage} from '../error'

export default function Login({ history }) {

    const initialState = {
        email: '',
        password: ''
    }
    const [state, setState] = useState(initialState)
    const [errors, setError] = useState({})

    const formSchema = Yup.object().shape({
        email: Yup.string()
            //.email()
            .required(),
        password: Yup.string()
            .min(8, 'Must be at least 8 characters')
            .required()
    });

    const handleInputChange = (e, {name, value}) => {
        if (errors[name] === true) {
            setError( errors => {
                return {
                    ...errors,
                    [name]: false
                }
            })
        }

        setState( state => {
            return {
                ...state,
                [name]: value
            }
        })
    }

    const handleSubmit = () => {

        setError({})
        formSchema.validate(state, {abortEarly: false}).then( data => {
            const reply = LoginPost(`/login`, data)

            reply.then(res => {

                //console.log(res.headers.jwt)
                if (res.data.success === true) {
                    setState(initialState);
                    setError({})
                    localStorage.setItem("token", res.headers.jwt)
                    history.push('/dashboard')
                }
            }).catch( error => {
                const errorFields = {}

                /*for (const [key, value] of Object.entries(error.response.data.messages)) {
                    errorFields[key] = getApiResponseErrorMessage({key: value, prefix: fieldNames[key]})
                }*/
                if(error.response && error.response.data && error.response.data.statusMessage === "incorrect email") errorFields['email'] = "Incorrect email"
                if(error.response && error.response.data && error.response.data.statusMessage === "Incorrect password") errorFields['password'] = "Incorrect password"


                setError( err => {
                    return {
                        ...err,
                        ...errorFields
                    }
                })
                setState( state => {
                    return {
                        ...state,
                    }
                })
            })

        }).catch( errors => {

            console.log(errors)

            const errorFields = {}

            errors.inner.forEach( error => errorFields[error.path] = error.message.replace(error.path, fieldNames[error.path]))//true)

            setError( err => {
                return {
                    ...err,
                    ...errorFields
                }
            })

        })
    }

    return (
        <div className={styles.root}>

            <div className={styles.content}>

                <h2>Sign in</h2>

                <Form onSubmit={handleSubmit}>

                    <Form.Field>
                        <Form.Input
                            name="email"
                            value={state.email}
                            error={errors.email}
                            icon="mail"
                            iconPosition="left"
                            label="Email"
                            placeholder="Enter email"
                            size="large"
                            onChange={handleInputChange}
                        />
                    </Form.Field>

                    <Form.Field>
                        <Form.Input
                            name="password"
                            value={state.password}
                            error={errors.password}
                            type="password"
                            icon="key"
                            iconPosition="left"
                            label="Password"
                            placeholder="Enter password"
                            size="large"
                            onChange={handleInputChange}
                        />
                    </Form.Field>

                    <Form.Group widths="equal">
                        <Form.Field>
                            <Button type="submit">Sign in</Button>
                        </Form.Field>

                        {/*<Form.Field className={styles.textRight}>
              <Link to="/forgotten-password">
                Forgotten password
              </Link>
            </Form.Field>*/}
                    </Form.Group>

                </Form>

            </div>

        </div>
    )

}
